// extracted by extract-css-chunks-webpack-plugin
module.exports = {"board":"Board__board___1W8nC","linkContainer":"Board__linkContainer___1tIzq","title":"Board__title___2kjmx","ideaCount":"Board__ideaCount___WqbPH","link":"Board__link___3zG5c","childrenToggle":"Board__childrenToggle___28piz","expanded":"Board__expanded___XlEQQ"};
    if(module.hot) {
      // 1751719785187
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  